<template>
  <div class="content_box">
    <!-- 图片列表 -->
    <div class="newsBox">
      <div v-if="infoList.length > 0" class="list-box">
        <van-pull-refresh v-model="isDownLoading" @refresh="onDownRefresh">
          <van-list v-model="isUpLoading" :finished="upFinished" :immediate-check="false"
                    :offset="offset" finished-text="" @load="onLoadList">
            <ul class="newsUl van-clearfix" v-if="infoList.length > 0">
              <li v-for="(item,$index) in infoList" @click="gotoMenu(item)">
                <div class="boxItem">
                  <img :src="item.imgUrl ?imageHost+item.imgUrl:require('@/assets/img/diseasesencyclopedia_icon_disease@2x.png')"  class="imgUrl">
                  <div class="newsTitle">
                    {{item.name}}
                  </div>

                </div>

              </li>
            </ul>
          </van-list>
        </van-pull-refresh>
      </div>
      <div v-else class="noPart">
        <!--          <img src="@/assets/information/no_article.png" class="no_article" />-->
        <div>暂时还没有数据</div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from "@/utils/index";
import EnvionmentVariables from '../../../../baseUrl'
export default {
  data () {
    return {
      imageHost: EnvionmentVariables.IMAGE_HOST,
      infoList: [],
      wikiList: [],
      pid: 0,
      searchValue: "",
      loading: false,
      finished: false,
      pageIndex: 1, // 请求第几页
      pageSize: 14, // 每页请求的数量
      total: 0, // 总共的数据条数
      article_type: "",
      isDownLoading: false, // 下拉刷新
      isUpLoading: false, // 上拉加载
      upFinished: false, // 上拉加载完毕
      offset: 100, // 滚动条与底部距离小于 offset 时触发load事件
      timer: null, // 下拉刷新定时器、
      title: ""
    };
  },
  computed: {},
  beforeCreate () {
    document.querySelector('body').setAttribute('style', 'background-color:#F8F8F8;');
  },
  methods: {
    setTitle() {
      console.log("this.$route.query")
      console.log(this.$route.query)
      console.log("title")
      console.log(this.$route.query.title)
      let title = decodeURIComponent(this.$route.query.title);
      console.log(title + "  -----")
      this.title = title;
      document.title = title;
    },
    // 获取分类列表
    getWikiCategory() {
      var that = this;
      this.$api.GetAppWiKiCategoryByPage({
        query: this.pid,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        service: "appagg"
      }).then(res => {
        if (res.status == 200) {
          that.total = res.data.rows;
          // 数据全部加载完成
          if (that.infoList.length >= that.total) {
            that.upFinished = true; // 加载结束
          } else {
            that.infoList = that.infoList.concat(res.data.result);
          }
          if (res.data.result.length < that.pageSize) {
            that.upFinished = true;
          }
        } else {
          this.loading = false;
        }
      }).catch(err => {
        console.log(err);
      }).finally(() => {
        console.log('finally')
        this.isDownLoading = false;
        this.isUpLoading = false;
      })
    },
    gotoMenu (item) {
      this.$router.push({
        path: "/encyclopediaList",
        query: {
          ...this.$route.query,
          pid: item.id,
          title: item.name
        }
      });
    },
    // 去详情
    toDetails(id) {
      this.$router.push({
        path: "/drugContent",
        query: { ...this.$route.query, id: id }
      });
    },
    // 下拉刷新
    onDownRefresh () {
      this.timer = setTimeout(() => {
        this.pageIndex = 1;
        this.infoList = [];
        this.upFinished = false // 不写这句会导致你上拉到底过后在下拉刷新将不能触发下拉加载事件
        this.getWikiCategory(); // 加载数据
        this.timer = null //清空定时器
      }, 300)
    },
    // 上拉加载
    onLoadList () {
      this.pageIndex++;
      this.getWikiCategory();
    }
  },
  created () {
    if (this.$route.query.pid) this.pid = parseInt(this.$route.query.pid);
    this.getWikiCategory();
    this.setTitle();
  },
  mounted () {

  }
};
</script>
<style scoped lang="less">
  .imgUrl{
    width: 80px;
    height: 80px;
    display: block;
    margin: auto;
    padding-top: 40px;
  }
  .boxItem{
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
    background: #fff;
    border-radius: 12px;
    margin-top: 16px;
    padding: 20px 0;
    height: 200px;
  }
  .healthencyclopedia_icon_search {
    width: 48px;
    height: 48px;
    padding: 0 10px;
    border: 0;
    vertical-align: middle;
  }
  .partner{
    color: #969799;
    font-size: 28px;
    line-height: 50px;
    text-align: center;
  }
  .closeAll{
    width: 40px;
    height: 40px;
    float: right;
    margin-top: 20px;
    margin-right: 23px;
  }
  .noPart{
    margin-top: 20px;
    text-align: center;
    color: #CACACA;
    font-size: 24px;
  }
  .no_article{
    width: 100px;
    height: 100px;
    margin: 285px auto 40px;
  }
  .liSome{
    width: 100%;
    height: 70px;
    line-height: 70px;
    color: #5F5E5E;
    font-size: 30px;
    text-align: center;
    background: #F5F5F5;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .liSome.active{
    color: #E52317;
  }
  .moreUl{
    padding: 30px 16px 0;
  }
  .moreLi{
    width: 25%;
    float: left;
    padding: 0 8px 16px;
    box-sizing: border-box;
  }
  .commit{
    width: 180px;
    display: inline-block;
  }
  .newsTime{
    width: 260px;
    display: inline-block;
  }
  .someDetail{
    color: #BFBEBE;
    font-size: 24px;
    display: flex;
  }
  .news_title{
    flex: 1;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .newsTitle{
    font-size: 26px;
    color: #3E3E3E;
    text-align: center;
    margin-top: 20px;
    padding: 0 30px;
  }
  .newsUl > li{
    width: 33.33333%;
    float: left;
    padding: 0 11px;
    box-sizing: border-box;
  }
  .newsUl{
    padding: 18px 20px 0 20px;
  }
  .more{
    width: 30px;
    height: 30px;
    position: absolute;
    top:29px;
    right: 25px;
  }
  .topNavOccupie{
    height: 88px;
    width: 100%;
  }
  .topNav{
    width: 100%;
    position: fixed;
    box-sizing: border-box;
    height: 88px;
    line-height: 88px;
    background: #FFF1F0;
    top:0;
    z-index: 1000;
  }
  #appNav{
    width: 100%;
    height: 100%;
    overflow:hidden;
  }
  #appNav nav{
    padding: 0 10px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: middle;
    -ms-flex-align: middle;
    align-items: middle;
    overflow: auto;
  }
  #appNav p{
    text-align: center;
    font-size: 28px;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    padding: 0px 50px;
    height: 100%;
    position: relative;
  }
  #appNav p.active{
    color: #E52317;
  }
  #appNav p.active::after{
    content: "";
    display: block;
    position: absolute;
    width: 45px;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    height: 4px;
    background: #E52317;
    border-radius: 2px;
  }












  .activity_name{
    font-size: 30px;
    color: #1E1E1E;
    margin-bottom: 10px;
  }
  .actText{
    font-size: 24px;
    color: #AEADAD;
    width: 100%;
    text-align: center;
  }
  .noAct{
    width: 246px;
    height: 180px;
    display: block;
    margin: 273px auto 33px;
  }
  .intro{
    padding-top:10px;
    font-size:24px;
    color: #9E9C9C;
    line-height: 1.6;
  }
  .state{
    color: #0082CD;
    font-size: 24px;
  }
  .state.over{
    color: #ABAFAE;
  }
  .state.ing{
    color: #FC5943;
  }
  .actLi{
    border-radius: 10px;
    background: #fff;
    box-shadow:0px 5px 6px 0px rgba(44,45,45,0.06);
    margin-bottom: 22px;
  }
  .commonPadding{
    padding: 22px 24px 0;
  }
  .actPic{
    width: 100%;
    height: 284px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    display: block;
  }
  .title{
    font-size: 26px;
    color: #1E1E1E;
    height: 60px;
  }
  .bor{
    width: 100%;
    border-bottom: 2px dashed #E5E5E5;
  }
  .detail{
    padding: 0 25px 32px;
  }
  .voteNo {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 25px;
    height: 65px;
    background:rgba(32,32,32,0.47);
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    box-sizing: border-box;
    font-size: 22px;
    color: #fff;
  }
  .posR{
    position: relative;
    width: 100%;
  }
  .icon{
    width: 32px;
    height: 32px;
    margin-right: 15px;
  }
  .flexCenter{
    display: flex;
    align-items: center;
  }
  .allCenter{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .firsIcon{
    margin-right:45px ;
  }

</style>

